module.exports = __webpack_public_path__ + "static/media/WaterChestNut 100g.e7f11e17.jpg";